import { InputText } from 'primereact/inputtext';
import './App.css';
import { Button } from 'primereact/button';
import V2HomeCard from './V2HomeCard';
import { createDevice } from './QueryDevice';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function V2DeviceNew({ menu }) {
    const navigate = useNavigate();
    const [title, setTitle] = useState('');

    return (
        <div align='center'>
            {menu}
            <V2HomeCard>
                <div align='center'>
                    <div
                        style={{
                            width: '20em'
                        }}
                        align='left'
                    >
                        <div className='mk2-title'>
                            Setup new screen
                        </div>
                        <div>
                            Give your screen a same, so you can identify later.
                        </div>
                        <div style={{ marginTop: '1em' }}>
                            <InputText
                                placeholder='name, eg.: device123'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div
                            style={{ marginTop: '1em' }}
                        >
                            <Button
                                severity='success'
                                label='Continue'
                                size='small'
                                outlined
                                onClick={
                                    () => {
                                        createDevice({ title: title }).then(
                                            (response) => {
                                                const device_id = response.data.device_id;
                                                navigate(`/device/campaigns/?device_id=${device_id}`);
                                            }
                                        ).catch(
                                            (error) => {
                                                console.log(error);
                                            }
                                        )
                                    }
                                }
                                disabled={title == ''}
                            />
                        </div>
                    </div>
                </div>
            </V2HomeCard>
        </div>
    );
}

export default V2DeviceNew;